var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{attrs:{"lg":"4","md":"6"}},[_c('div',{staticClass:"mb-3 bg-grey rounded p-5 text-center"},[_c('b-icon',{attrs:{"icon":_vm.item.icon,"variant":"info","scale":"2.5"}}),_c('h5',{staticClass:"text-secondary my-3"},[_vm._v(_vm._s(_vm.item.name))]),_c('p',{staticClass:"text-grey"},[_vm._v(_vm._s(_vm.item.description))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }